export const formatDate = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '-' : date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const formatPeriod = (value) => {
  if (!value) return '-';
  const date = new Date(`${String(value).slice(0, 10)}T00:00:00`);
  return Number.isNaN(date.getTime()) ? String(value).slice(0, 10) : date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
};

export const normalizeInvoiceStatus = (invoice) => {
  if (invoice?.reversed === true || invoice?.reversed === 't' || invoice?.reversed === 1 || invoice?.reversed === '1') return 'REVERSED';
  const status = String(invoice?.invoice_status || 'DRAFT').trim().toUpperCase();
  return ['DRAFT', 'SENT', 'PAID'].includes(status) ? status : 'DRAFT';
};

export const statusBadgeClass = (status) => {
  if (status === 'DRAFT') return 'bg-amber-100 text-amber-800';
  if (status === 'SENT') return 'bg-sky-100 text-sky-800';
  if (status === 'PAID') return 'bg-emerald-100 text-emerald-800';
  if (status === 'REVERSED') return 'bg-rose-100 text-rose-700';
  return 'bg-slate-100 text-slate-700';
};
